import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-medication",
  "use": "icon-medication-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-medication\"><defs><style type=\"text/css\"></style></defs><path d=\"M390.4 980.608a258.176 258.176 0 0 1-129.92-35.072 260.864 260.864 0 0 1-95.36-355.968L396.8 188.288a261.12 261.12 0 0 1 356.096-95.488 261.12 261.12 0 0 1 95.36 356.096l-231.68 401.28A261.376 261.376 0 0 1 390.4 980.608z m232.448-850.176a188.032 188.032 0 0 0-163.328 94.08L227.84 625.792a188.16 188.16 0 1 0 326.016 188.16l231.68-401.28A188.544 188.544 0 0 0 716.8 155.52a187.648 187.648 0 0 0-93.952-25.088z\" fill=\"#0099FF\" p-id=\"1451\" /><path d=\"M427.136 439.808l188.032 108.672a36.096 36.096 0 0 1 12.8 49.408 36.352 36.352 0 0 1-49.536 12.8l-187.52-108.16a36.224 36.224 0 0 1-12.8-49.408 36.352 36.352 0 0 1 49.024-13.312z\" fill=\"#0099FF\" p-id=\"1452\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/medication.svg
// module id = QUJP
// module chunks = 81